<template>
  <Validator label="" :v="v" input>
    <div class="custom-input">
      <div
        :class="{
          'outline-block': true,
          'outline-block--focus': inputFocus,
          'outline-border-error': v.$invalid && v.$dirty || validation
        }">
        <select
          :aria-label="label"
          ref="select"
          :disabled="disabled"
          :readonly="readonly"
          :required="required"
          :class="{ 'outline-border-error': (v.$invalid && v.$dirty) || validation, 'outline-input outline-input-select value-typography': true }"
          @input="$emit('input', $event.target.value)"
          @blur="onBlur"
          @change="onChange"
          @focus="onFocus">
          <option v-for="op in options" :key="op.key" :selected="value == op.value" :value="op.value" :title="op.title">{{ op.text }}</option>
        </select>

        <div
          :class="{
            'outline-label' : true,
            'outline-label-up': (value !== '') || inputFocus,
            'outline--focus': inputFocus,
            'outline-error': v.$invalid && v.$dirty
          }">
          {{ label }}
        </div>
        <div class="outline-disabled"></div>
        <v-icon class="outline-icon-right">arrow_drop_down</v-icon>
      </div>
    </div>
  </Validator>
</template>

<script>
import Validator from './Valitador.vue';

export default {
  name: 'Select',
  components: {
    Validator,
  },
  props: {
    value: [ String, Number, Object, Array ],
    options: Array,
    label: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    v: {
      type: Object,
      default() {
        return {
          $invalid: false,
          $dirty: false,
          $touch: () => {},
        };
      },
    },
  },
  data() {
    return {
      inputFocus: false,
    };
  },
  methods: {
    onFocus() {
      this.inputFocus = true;
      this.$emit('focus');
    },
    onBlur() {
      this.v.$touch();
      this.inputFocus = false;
      this.$emit('blur');
    },
    onChange(e) {
      this.v.$touch();
      this.$emit('change');
    },
  },
};
</script>

<style lang="scss">
.value-typography  {
  font-size: 14px !important;
}

.errorBorder{
  border: 1px solid red;
}

.outline-input-select {
  padding: 12px 28px 10px 16px!important;
}

.select-custom{
  width: 100%;
  border: 1px solid #b0b0b0;
  border-radius: 4px;
  font-size: 17px;
  padding: 2px;
  background-color: white;
  -webkit-appearance: menulist;
  height: 31px;

  &:disabled{
    background-color: #e8e8e8;
  }

  &::-ms-expand{
    display: block;
    visibility: initial;
  }
}
</style>
